import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonWrapper"},[_c('button',{staticClass:"windowButton"},[_c(VIcon,{attrs:{"size":20}},[_vm._v("mdi-window-minimize")])],1),_c('button',{staticClass:"windowButton specialHighlight"},[_c(VIcon,{attrs:{"size":20}},[_vm._v("mdi-window-close")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }